var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160",
    transform: "translate(12613 13985)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 24,
    height: 24,
    transform: "translate(-12613 -13985)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1160-2",
    "data-name": "Group 1160",
    transform: "translate(-2.069 -2.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-right",
    d: "M0,0,6.594,6.593a2.008,2.008,0,0,1,0,2.832L0,16.019",
    transform: "translate(-12606.941 -13960.001) rotate(-90)",
    fill: "none",
    stroke: "#303763",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-right-2",
    "data-name": "arrow-right",
    d: "M0,16.019,6.594,9.425a2.008,2.008,0,0,0,0-2.832L0,0",
    transform: "translate(-12590.921 -13980.663) rotate(90)",
    fill: "none",
    stroke: "#303763",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.026ba9e795c408776c20151296ec8ddb.svg";
export { ForwardRef as ReactComponent };